<div class="form-element" [ngClass]="{last: 'form-element--last'}">
  <div nxRow rowJustify="between">
    <div nxCol="12,12,6,7,7">
      <div class="form-element_first">
        <h2 nxHeadline="section" class="form-element_headline">
          {{ header | translate }}
          <nx-icon
            *ngIf="tooltip"
            name="info-circle-o"
            class="form-element_tooltip"
            nxTooltipPosition="top"
            [nxTooltip]="tooltip | translate"
          />
        </h2>
        <ng-content select="[description]"></ng-content>
      </div>
    </div>
    <div nxCol="12,12,6,5,5">
      <div class="form-element_last">
        <div class="u-df-c">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
